import React from 'react';
import { Link } from 'react-router-dom';
import { brand } from '../../stringConstants';
import { PLAYER_BASE_URL } from '../../constant';

const TrayvoBadge = ({ color }) => {
  return (
    <div
      style={color && { backgroundColor: color }}
      className="bg-primary-color rounded-md hover:bg-gray-700">
      <Link to={{ pathname: PLAYER_BASE_URL }}
        target='_blank'
        rel='noopener noreferrer'
        className="flex font-sf-regular text-sm px-2 py-1">
        <small style={{ color: '#CECECE' }}>fueled by</small>

        <small className="text-white pl-1">{brand}</small>
      </Link>
    </div>
  );
};

export default TrayvoBadge;
